/**
 * 使い方ページ（ESJ が公開している、アプリの外のサイト。課題 #101）へのリンク。
 * アプリの画面を離れないよう、新しいタブで開く（2026-10-14 高尾さん依頼）。
 *
 * 結果の見方の各節（#s1 録音のしかた・#s2 今日の振り返り・#s3 月のスコア）へのリンクは、
 * 10/14 の定例で決めた画面の文言の変更と同時に出す（ページと画面の言い方をそろえるため）。
 */
export const MANUAL_TOP_URL = 'https://ceeu-mental.es-jpn.jp/manual/ceeu-mental/';
